import * as React from 'react';
import styles from './styles.module.sass';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import MenuIcon from '@material-ui/icons/Menu';

interface IProps {
  onNavClicked(): void;
}
export default class Header extends React.Component<IProps> {
   render() {
    return (
      <div>
      <AppBar position='static'>
        <Toolbar className={styles.header}>
          <IconButton color='inherit' aria-label='Menu' onClick = {() => this.props.onNavClicked()}>
            <MenuIcon/>
          </IconButton>
          <Typography variant='h1' color='inherit' className={styles.header_title}>
            Student
          </Typography>
        </Toolbar>
      </AppBar>
    </div>
    );
  }
}
